import {ChangeDetectionStrategy, Component, NgModule, ViewEncapsulation} from '@angular/core';

/**
 * @ngModule AlertFuncExclamationCircleSvgModule
 */
@Component({
  selector: 'svg[systemcodeAlertFuncExclamationCircle]',
  template: '<svg:g class="nc-icon-wrapper" transform="matrix(.8 0 0 .8 2.4 2.4)" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3"><svg:circle cx="12" cy="12" r="11" fill="none" stroke-miterlimit="10"></svg:circle><svg:path data-color="color-2" fill="none" stroke-miterlimit="10" d="M12 7v6"></svg:path><svg:circle data-color="color-2" data-stroke="none" cx="12" cy="17" r="1" stroke="none"></svg:circle></svg:g>',

  styles: [
    ':host { fill: currentColor; stroke: currentColor; }',
      ],

  host: {
    'viewBox': '0 0 24 24',
  },

  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertFuncExclamationCircleSvgComponent {
}

@NgModule({
  declarations: [
    AlertFuncExclamationCircleSvgComponent,
  ],
  exports: [
    AlertFuncExclamationCircleSvgComponent,
  ],
})
export class AlertFuncExclamationCircleSvgModule {}
